import cn from 'classnames';

const KdRowLabel = ({ text }: { text: string }) => {
  const classnames = cn(
    'w-[100px] h-[29px] text-[#FCBC00] italic text-[16px] sm:text-[20px]'
  );
  return <div className={classnames}>{text}</div>;
};
export default KdRowLabel;
